import { jsxs, jsx } from "react/jsx-runtime";
import lessonNumberSvg from "../assets/print/lesson-number.svg.js";
import { LAYOUT, mmToPx, BLEED_SIZE_MM } from "./constants.js";
const BLEED_CROP = mmToPx(BLEED_SIZE_MM);
function ChapterNumber({ number, bleedPx = 0 }) {
  const hasBleed = bleedPx > 0;
  const crop = hasBleed ? 0 : BLEED_CROP;
  const w = LAYOUT.chapterNumber.width - crop;
  const h = LAYOUT.chapterNumber.height - crop;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "absolute top-0 left-0",
      style: { width: w, height: h, overflow: "hidden", zIndex: 1 },
      children: [
        /* @__PURE__ */ jsx(
          "img",
          {
            src: lessonNumberSvg,
            alt: "",
            width: LAYOUT.chapterNumber.width,
            height: LAYOUT.chapterNumber.height,
            style: hasBleed ? void 0 : { marginLeft: -BLEED_CROP, marginTop: -BLEED_CROP }
          }
        ),
        /* @__PURE__ */ jsx(
          "span",
          {
            className: "absolute text-white font-dunggeunmiso",
            style: {
              top: LAYOUT.chapterNumber.numberTop - crop,
              left: LAYOUT.chapterNumber.numberLeft - crop,
              fontSize: LAYOUT.chapterNumber.fontSize,
              fontWeight: 700,
              letterSpacing: "3.2px",
              lineHeight: 1,
              textAlign: "center"
            },
            children: number
          }
        )
      ]
    }
  );
}
export {
  ChapterNumber
};
//# sourceMappingURL=ChapterNumber.js.map
